<template>
  <div class="program-full-item">
    <div class="item-img" @click="godetail(item)">
      <img :src="item.cover_img" alt="" @error="imgError(item)">
      <div class="defaultRedBtnBox flex" v-if="item.award">
        <div class="defaultRed-btn">
          <div class="btn item-tips ellipsis">{{ item.award }}</div>
        </div>
      </div>
      <div class="item-play" v-if="item.good_show_type">
        <span class="iconfont icon-video" v-if="item.good_show_type == '视频'"></span>
        <span class="iconfont icon-voiceprint-line" v-else-if="item.good_show_type == '音频'"></span>
        <span class="iconfont icon-tupian" v-else-if="item.good_show_type == '图片'"></span>
      </div>
    </div>
    <div class="item-txt">
      <div class="item-sub">
        <span v-if="item.type_tag_name">{{ item.type_tag_name | formatShowFirst }}</span>
        <span v-if="item.show_time">{{ item.show_time | formatStandardDate }}</span>
      </div>
      <h3 class="item-title" :title="item.name" @click="godetail(item)">{{ item.name }}</h3>
      <div class="item-intro" v-if="item.activity_name">
        <em>专题活动：</em><span @click="goActivity(item)">{{ item.activity_name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import colums from '@/colums/colums'
export default {
  name: 'programFullItem',
  props: {
    item: Object,
    showpath: String
  },
  data() {
    return {
      programColum: colums.jmkcate
    }
  },
  mounted() {

  },
  methods: {
    godetail(info) {
      let hash = this.$utils.hashNum(info.no_access)
      this.$router.push({
        path: '/program/' + info.id + "/" + hash
      })
    },

    goActivity(info) {
      const path = "/activity/" + info.activity_id
      try {
        let link = this.$router.resolve({
          path
        })
        window.open(link.href, "_blank")
      } catch (error) {
        this.$router.push({
          path
        })
      }

    }
  },
}
</script>
<style lang="scss" scoped>
.program-full-item {
  .item-img {
    img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>